import classNames from "classnames/bind";
import styles from "./Filter.module.css";
import { Form } from "antd";
import { FormInfo } from "../../../../components";
import { useEffect, useState } from "react";
import { company } from "../../../../services/api/comaniesService";

const cx = classNames.bind(styles);

function Filter({ form }) {
    const [filterCompnay, setFilterCompany] = useState([]);

    useEffect(() => {
        const getListCompany = async () => {
            try {
                const res = await company.get();
                if (res) {
                    const listCompany = res?.data?.map(item => {
                        return {
                            label: item?.NAME || "",
                            value: item?.CODE || ""
                        }
                    })
                    setFilterCompany(listCompany)
                    form?.setFieldValue("company", listCompany[0].value)
                }

            } catch (error) {
                // console.log(error);
            }
        }
        getListCompany()
    }, [])
    const filter = [
        {
            label: "Tên công ty",
            type: "select",
            name: "company",
            span: 6,
            options: filterCompnay
        },
    ]
    return (
        <div className={cx("filter")}>
            <FormInfo form={form} listInfo={filter} gutter={[0, 0]} />
        </div>
    )
}

export default Filter;